import { DocumentInterface } from './Documents'

export type DocumentV2State = 'published' | 'unpublished' | 'deleted'
export type DocumentV2Source = 'customer' | 'operations' | 'finance' | 'auto-fetched'

export type DocumentV2 = {
  id: string
  legacyID?: string
  createdAt: Date
  // FIXME: Extract an interface for this once it is used. Because of ts-prune
  // it cannot be added sooner. But we need the type information to make sure
  // this is not missed.
  createdBy:
    | string
    | {
        id: string
        fullName: string
        email: string
      }
  updatedAt: Date
  updatedBy:
    | string
    | {
        id: string
        fullName: string
        email: string
      }

  customerID: string

  state: DocumentV2State

  entityType: string
  entityID: string

  fileName: string
  mimeType: string
  s3FileName: string
  bucket: string
  source: DocumentV2Source

  documentTypeCode: string
  documentType?: DocumentType

  publishedVersion: number
  version: number
  templateID?: string

  containerNumbers?: string[]
}

export type PaginatedDocuments = {
  limit: number
  offset: number
  orderBy: string
  results: DocumentV2[]
  total: number
}

export type ManualQuoteDocument = DocumentV2 & { entity: 'manual-quote' }
export type BookingDocument = DocumentV2 & { entity: 'booking' }

export const mapToDocumentInterface = (doc: DocumentV2): DocumentInterface => ({
  _id: doc.id,
  createdAt: doc.createdAt,
  customer_id: doc.customerID,
  file: doc.s3FileName,
  mimeType: doc.mimeType,
  modifiedAt: doc.updatedAt,
  name: doc.fileName,
  role: doc.documentTypeCode,
  userProvided: doc.source === 'customer',
  publishedVersion: doc.publishedVersion,
  isGenerated: Boolean(doc.templateID),
  containerNumbers: doc.containerNumbers,
})
